module.exports = __webpack_public_path__ + "static/media/orders-highlight-admin-icon.d390bc4e.svg";